module.exports = __webpack_public_path__ + "img/Financial_Services.fd50b24d.svg";